import { render, staticRenderFns } from "./UserDetailsRoot.vue?vue&type=template&id=26de08eb"
import script from "./UserDetailsRoot.vue?vue&type=script&lang=js"
export * from "./UserDetailsRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports